export function trimTrailingZeros(value: string | number): string {
  // Преобразуем в строку, если передано число
  const strValue = typeof value === 'number' ? value.toString() : value

  // Удаляем лишние нули после точки
  return strValue.includes('.')
    ? strValue.replace(/(?:\.0+|(\.\d+?)0+)$/, '$1')
    : strValue
}
